var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.434,
    height: 39.765,
    viewBox: "0 0 40.434 39.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON-LOGOUT",
    transform: "translate(-740.137 -102.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2105",
    "data-name": "Trazado 2105",
    d: "M768.225,132.987a1.56,1.56,0,1,0-3.107,0c0,.932,0,1.864,0,2.8a3.123,3.123,0,0,1-3.279,3.269q-7.643.008-15.286,0a3.122,3.122,0,0,1-3.292-3.295q0-13.473,0-26.946a3.739,3.739,0,0,1,.121-1,3.076,3.076,0,0,1,3.12-2.307c2.269-.007,4.538,0,6.807,0h8.4a3.15,3.15,0,0,1,3.405,3.417c0,.88,0,1.76,0,2.64a1.561,1.561,0,1,0,3.11.015q.007-1.437,0-2.873a6.213,6.213,0,0,0-6.308-6.3q-7.74-.018-15.48.012a6.744,6.744,0,0,0-2.094.345,6.15,6.15,0,0,0-4.2,6q-.005,12.755,0,25.509c0,.621-.025,1.244.01,1.863a6.044,6.044,0,0,0,3.5,5.378,13.065,13.065,0,0,0,2.015.648h17.036a1.191,1.191,0,0,1,.212-.074,6.107,6.107,0,0,0,5.222-5.3A36.552,36.552,0,0,0,768.225,132.987Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2106",
    "data-name": "Trazado 2106",
    d: "M960.63,278.03l-4.1-4.03-.437-.429a1.417,1.417,0,0,0-1.366-.374,1.535,1.535,0,0,0-.782,2.587c.708.755,1.46,1.471,2.191,2.205.076.077.143.163.256.292h-18.55a1.953,1.953,0,0,0-.206.009,1.5,1.5,0,0,0-1.335,1,1.476,1.476,0,0,0,.329,1.619,1.705,1.705,0,0,0,1.344.486q8.965-.008,17.93,0h.539c-.845.84-1.623,1.582-2.359,2.362a2.226,2.226,0,0,0-.535.915,1.456,1.456,0,0,0,.745,1.643,1.5,1.5,0,0,0,1.829-.236c.139-.135,2.7-2.688,4.515-4.5A2.494,2.494,0,0,0,960.63,278.03Z",
    transform: "translate(-180.805 -157.477)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/ICON-LOGOUT.fc1563c40926fb59d5f8eba562cd801c.svg";
export { ForwardRef as ReactComponent };